import React from 'react';
import PropTypes from 'prop-types';
import DataContainer from 'Components/UI/DataContainer';
import InflowsMoneyFlowsSection from './InflowsMoneyFlowsSection';

export const InflowsMoneyFlowsSectionContainer = ({ relationship }) => {
  const [resource, setResource] = React.useState(null);

  const fetchData = async (rel) => {
    const [sectionResource] = await rel.getRelated();
    setResource(sectionResource);
  };

  React.useEffect(() => {
    if (relationship) {
      fetchData(relationship);
    }
  }, [relationship]);


  return (
    <DataContainer
      component={InflowsMoneyFlowsSection}
      componentProps={{
        resource,
      }}
      loading={!resource}
    />
  );
};

InflowsMoneyFlowsSectionContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
};
